import { useContext } from "react"
import PropTypes from "prop-types"
import { MultiContext } from "~/contexts/MultiContext"
import { MiniLayout } from "./MiniLayout"

Panel.propTypes = {
  children: PropTypes.node,
}
export function Panel({ children }) {
  return <>{children}</>
}
Panel.Heading = Heading
Panel.Buttons = Buttons
Panel.HeadingDescription = HeadingDescription
Panel.HeadingForm = HeadingForm
Panel.Layout = Layout

Heading.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}
function Heading({ children, className = "" }) {
  return (
    <div className={`flex flex-col justify-between pb-4 sm:min-h-24 ${className}`}>{children}</div>
  )
}

Buttons.propTypes = {
  children: PropTypes.node,
}
function Buttons({ children }) {
  return <div className="flex min-h-24 flex-row justify-center gap-2">{children}</div>
}

HeadingDescription.propTypes = {
  children: PropTypes.node,
}
function HeadingDescription({ children }) {
  return <div className="text-sm text-gray-700">{children}</div>
}

HeadingForm.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
}
function HeadingForm({ id, value, onChange }) {
  const { setIsCommandMenuFocused } = useContext(MultiContext)

  return (
    <input
      type="text"
      name={id}
      id={id}
      onFocus={() => setIsCommandMenuFocused(true)}
      onBlur={() => setIsCommandMenuFocused(false)}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-none sm:text-sm/6"
    />
  )
}

Layout.propTypes = {
  Icon: PropTypes.object,
  onClick: PropTypes.func,
  enabledOptions: PropTypes.string,
}
function Layout({ Icon, onClick, enabledOptions }) {
  return <MiniLayout Icon={Icon} onClick={onClick} enabledOptions={enabledOptions} />
}
